import React from 'react';
import Navbar from '../Navbar/Navbar';

const Header: React.FC = () => {
  return (
    <header>
      <Navbar />
    </header>
  );
};

export default Header;
